import { createSlice } from "@reduxjs/toolkit";
import { getChildLocationThunk, getParentLocationThunk } from "../thunks/locationThunk";

const initialState = {
  locations: {}
};

const getParentLocationSlice = createSlice({
  name: "getParentLocationSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getParentLocationThunk.pending, (state, action) => {
        const type = action.meta.arg;
        if (!state.locations) {
          state.locations = {};
        }
        state.locations = {
          ...(state.locations|| {}),
          loading: true,
          error: null,
        };
      })

      .addCase(getParentLocationThunk.fulfilled, (state, action) => {
        const {data } = action.payload;
        if (!state.locations) {
          state.locations = {};
        }
        state.locations = {
          data: data,
          loading: false,
          error: null,
        };
      })

      .addCase(getParentLocationThunk.rejected, (state, action) => {
        const type = action.payload || action.meta.arg;
        if (!state.locations) {
          state.locations = {};
        }
        state.locations = {
          ...(state.locations || {}),
          data: [],
          loading: false,
          error: action.payload?.message || "data error",
        };
      });
  },
});


const getChildLocationSlice = createSlice({
  name: "getChildLocationSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChildLocationThunk.pending, (state, action) => {
        const { locationType } = action.meta.arg.variables.filterInput;
        state.locations[locationType] = {
          ...(state.locations[locationType] || {}),
          loading: true,
          error: null,
        };
      })
      .addCase(getChildLocationThunk.fulfilled, (state, action) => {
        const { data } = action.payload;
        const { locationType } = action.meta.arg.variables.filterInput;
        state.locations[locationType] = {
          data: data,
          loading: false,
          error: null,
        };
      })
      .addCase(getChildLocationThunk.rejected, (state, action) => {
        const { locationType } = action.meta.arg.variables.filterInput;
        state.locations[locationType] = {
          ...(state.locations[locationType] || {}),
          data: [],
          loading: false,
          error: action.payload?.message || "Data error",
        };
      });
  },
});

export const childLocationReducer = getChildLocationSlice.reducer;
export const parentLocationReducer = getParentLocationSlice.reducer;